import { CanDeactivateFn } from '@angular/router';

type UploadBlockingComponent = {
  canLeavePage: () => boolean;
};

export const reportIncidentUploadGuard: CanDeactivateFn<UploadBlockingComponent> = (component) => {
  return component.canLeavePage();
};
